import { ContactCornSchema } from '@eigtech/contacts-types';
import { z } from 'zod';
export const BaseTemplateSchema = z.object({
    id: z.string(),
    name: z.string(),
    lastUpdated: z.string().optional(),
    createdOn: z.string(),
    modifiedBy: z.string().optional(),
    carrierContactCorn: ContactCornSchema.optional(),
    reasonForUpdate: z.string().optional(),
});
